import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import _ from 'lodash-es';
import { unitConversionNew } from '@/pages/dashboard/utils/utils';
import { mathFormat } from '@/pages/home/utils/search';
import ChartBubble from '@/pages/intelligence/components/ChartBubble';
import { newMathFormat } from '@/pages/intelligence/utils/commonUtils';
import { getLocale } from 'umi';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
const nowYear: string = moment().format('YYYY');
export const TOTAL_BAR_SERIES_NAME = 'Total';
export const colorShiBar: Array<string> = [
  'rgba(55, 106, 231, 1)',
  'rgba(62, 203, 255, 1)',
  'rgba(79, 203, 135, 1)',
  'rgba(255, 209, 78, 1)',
  'rgba(233, 95, 106, 1)',
  'rgba(207, 97, 172, 1)',
  'rgba(55, 106, 231, 1)',
  'rgba(62, 203, 255, 1)',
  'rgba(79, 203, 135, 1)',
  'rgba(255, 209, 78, 1)',
  'rgba(233, 95, 106, 1)',
  'rgba(207, 97, 172, 1)',
  'rgba(55, 106, 231, 1)',
  'rgba(62, 203, 255, 1)',
  'rgba(79, 203, 135, 1)',
  'rgba(255, 209, 78, 1)',
  'rgba(233, 95, 106, 1)',
  'rgba(207, 97, 172, 1)',
];
const colorTouBar: typeof colorShiBar = [
  'rgba(55, 106, 231, 0.4)',
  'rgba(62, 203, 255, 0.4)',
  'rgba(79, 203, 135, 0.4)',
  'rgba(255, 209, 78, 0.4)',
  'rgba(233, 95, 106, 0.4)',
  'rgba(207, 97, 172, 0.4)',
  'rgba(55, 106, 231, 0.4)',
  'rgba(62, 203, 255, 0.4)',
  'rgba(79, 203, 135, 0.4)',
  'rgba(255, 209, 78, 0.4)',
  'rgba(233, 95, 106, 0.4)',
  'rgba(207, 97, 172, 0.4)',
  'rgba(55, 106, 231, 0.4)',
  'rgba(62, 203, 255, 0.4)',
  'rgba(79, 203, 135, 0.4)',
  'rgba(255, 209, 78, 0.4)',
  'rgba(233, 95, 106, 0.4)',
  'rgba(207, 97, 172, 0.4)',
  'rgba(55, 106, 231, 0.4)',
  'rgba(62, 203, 255, 0.4)',
  'rgba(79, 203, 135, 0.4)',
  'rgba(255, 209, 78, 0.4)',
  'rgba(233, 95, 106, 0.4)',
  'rgba(207, 97, 172, 0.4)',
];
const formatName = (name?: string) => name === 'pc' ? 'PC' : _.startCase(name);
export const formatBarSrice = (
  arr: any,
  isLineHide?: boolean | undefined,
  isShowTopData?: boolean,
  SmallNumberIsShow?: boolean,
) => {
  if (!arr) return [];
  const dataSource = [...arr];
  let legend: String[] = [];
  let xAxis = [];
  // legend展示
  legend = dataSource.find((task) => task.metrics)?.metrics.map((task) => formatName(task.metric));
  // xAxis展示
  xAxis = dataSource.map((task) => task.date || (document.body.clientWidth > 1560 ? task?.region_en : task?.region));
  const obj = {};
  // 获取各类目数据
  const list = dataSource.map((task) => {
    let resultList: any = [];
    if (task?.metrics && Array.isArray(task?.metrics)) {
      resultList = task?.metrics?.map((item, index) => {
        if (legend?.includes(formatName(item?.metric))) {
          obj[item?.metric] = _.concat([], obj[item?.metric], {
            value: item?.total,
            date: task?.date,
          }).filter(Boolean);
        }
      });
    } else {
      for (const metricKey of legend) {
        obj[metricKey] = _.concat([], obj[metricKey], {
          value: '-',
          date: task?.date,
        }).filter(Boolean);
      }
    }
    return resultList;
  });
  // 获取顶部总合
  const topList = dataSource.map((task) => ({
    value: task.total,
    // _.sumBy(task.metrics, (o) => +task.total),
    itemStyle: {
      color: 'rgba(128, 128, 128, 0)',
    },
  }));
  // 获取各类目数据总合
  const seriesData = Object.keys(obj).map((task, index) => {
    const data = obj[task]?.map((ix) => ({
      value: +ix.value,

      itemStyle: {
        color: ix.date >= nowYear ? colorTouBar[index] : colorShiBar[index],
        borderWidth: 0.5,
        borderColor: '#fff',
        barWidth: 40,
      },
    }));
    const seriesList = {
      name: formatName(task),
      type: 'bar',
      stack: 'total',
      barCategoryGap: '50%',
      data,
      itemStyle: {
        color: colorShiBar[index],
      },
      z: 3,
      legendHoverLink: false,
    };
    return {
      ...seriesList,
    };
  });

  // 顶部top展示
  const topData = isShowTopData && {
    name: TOTAL_BAR_SERIES_NAME,
    type: 'bar',
    stack: '',
    barCategoryGap: '50%',
    data: topList,
    z: 4,
    barGap: '-100%',
    label: {
      show: true,
      position: 'top',
      valueAnimation: true,
      color: '#444',
      fontSize: 12,
      formatter(params: { value: number }) {
        return unitConversionNew(params?.value, {
          isFloat: true,
          fixedNum: document.body.clientWidth > 1600 ? 2 : !isLineHide && SmallNumberIsShow ? 1 : 0,
        });
      },
    },
  };
  // 获取折线数据
  const lineData = !isLineHide && {
    name: 'YoY',
    type: 'line',
    yAxisIndex: 1,
    axisValue: 123123,
    itemStyle: {
      borderColor: '#fff',
      color: '#ED9142',
    },
    data: dataSource.map((task) => task.total_dod),
    symbol: 'circle',
    symbolSize: 6,
    showSymbol: false,
    lineStyle: {
      color: '#ED9142',
    },
  };
  if (!isLineHide) legend = [...legend, 'YoY'];
  // 合并
  function capitalizeFirstLetter(string: any) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  const otherSeriesData = [lineData, topData].filter((item) => typeof item !== 'boolean');
  const series = _.concat([], seriesData, ...otherSeriesData);
  return {
    legend: legend.map((task: string) => (task === 'pc' ? 'PC' : capitalizeFirstLetter(task))).filter((item) => item !== TOTAL_BAR_SERIES_NAME),
    series,
    xAxis,
  };
};
// 是否纯数字type
export const stringToNumber = <T extends unknown>(value: T) => (isNaN(Number(value)) ? 0 : value);

export const formatGrowthDetails = <T extends unknown, S = string>(
  arr: T[],
  type: S,
  formatMessage?: (...args: any[]) => void,
) => {
  if (!arr) return [];
  const defaultConfig = {
    revenue: {
      title: ['Star Market 明星市场', 'Cash Cow 成熟市场', 'Question Mark 问号市场', 'Dogs 瘦狗市场'],
      color: [
        ['#7DADFF', '#CFE4FF'],
        ['#FFABAF', '#FFE6E6'],
        ['#92DEB4', '#DEF2E4'],
        ['#FFC182', '#FFECD4'],
      ],
      dataHeader: [
        formatMessage?.({ id: 'dbi_region' }),
        formatMessage?.({ id: 'dbi_revenue' }),
        formatMessage?.({ id: 'dbi_global_view_growth' }),
      ],
    },
    players: {
      title: [
        formatMessage?.({ id: 'dbi_global_view_play_payers' }),
        formatMessage?.({ id: 'dbi_global_view_play_little_payers' }),
      ],
      color: [
        ['rgb(125, 173, 255)', 'rgb(207, 228, 255)'],
        ['rgb(255, 171, 175)', 'rgb(255, 230, 230)'],
      ],
      dataHeader: [
        formatMessage?.({ id: 'dbi_region' }),
        formatMessage?.({ id: 'dbi_global_view_players' }),
        formatMessage?.({ id: 'dbi_global_view_play_annual' }),
      ],
    },
  }[type as string];

  const initialConfig = {
    title: defaultConfig?.title,
    color: defaultConfig?.color,
    dataHeader: defaultConfig?.dataHeader,
  };
  const dataSource = [...arr];
  return dataSource.map((task: any, taskIndex) => {
    const item = task?.countrys.slice(0, 5);
    const res = item.map(
      (item: { country: S; revenue: S; revenue_growth: S; players: S; annual_spend_per_payer: S }) => ({
        country: item.country,
        revenue: stringToNumber(item.players || item.revenue),
        // mathFormat(stringToNumber(item.players || item.revenue)),
        growth: `${
          type === 'players'
            ? _.round(+item.annual_spend_per_payer || +item.revenue_growth, 2)
            : _.round(+item.annual_spend_per_payer || +item.revenue_growth, 2) / 100
        }`,
      }),
    );
    return {
      title: initialConfig?.title?.[taskIndex],
      dataHeader: initialConfig.dataHeader,
      dataBody: res,
      color: [initialConfig?.color?.[taskIndex]?.[0], initialConfig?.color?.[taskIndex]?.[1]],
    };
  });
};

export function ChangeSize() {
  const [size, setSize] = useState({
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight,
  });

  const onResize = useCallback(() => {
    try {
      setSize({
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight,
      });
    } catch (_err) {}
  }, []);

  useEffect(() => {
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [onResize, size]);

  return size;
}

export const echartMapTooltip = (obj: {
  param: any;
  nameListObj: any;
  formatFunObj: any;
  letTitle?: string;
  rightTitle?: string;
}) => {
  const { param, letTitle, rightTitle, nameListObj, formatFunObj } = obj;

  let returnStr = `<div >
      <div style="font-size:12px;margin-bottom:4px;">
          <div style="color:#EBECF1;text-align: left;margin-right:20px;display:inline-block;">
              ${letTitle}
          </div>
          <div style="color:#EBECF1;float:right;display:inline-block;">
              ${rightTitle}
          </div>
      </div>`;
  let leftStr = '';
  let rightStr = '';
  // eslint-disable-next-line no-restricted-syntax
  for (const item in nameListObj) {
    const nameVal = nameListObj[item];
    const valueFormatFun = formatFunObj[item];
    const value = (param?.data && param?.data[item]) || '-';
    leftStr += `<div  style="margin-bottom:4px;">
    <span style="  font-weight: 500;
    font-size: 12px;color: #ebecf1;">${nameVal}</span>
    </div>`;
    rightStr += ` <div style="color:#EBECF1;font-weight:bold;text-align:right;margin-bottom:5px;" >
    ${valueFormatFun ? valueFormatFun(value) : value}
    </div>`;
  }
  returnStr += `<div style="display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;">
      <div  style="margin-right:20px">${leftStr}</div>
      <div style="font-size:14px" >${rightStr}</div>
    </div>`;
  return returnStr;
};

export const tooltipFormatter = (paramsOld: any, locale: string, title) => {
  const params = paramsOld?.filter((item: any) => item?.seriesName !== TOTAL_BAR_SERIES_NAME) || [];
  const res = params.map((task: { dataIndex: number; axisValue: string; seriesType: string; value: number }) => {
    return {
      ...task,
      axisValue:
        task.dataIndex > 2
          ? task.axisValue + (locale === LANGUAGE_CN ? '(数据预测)' : '(Data Predicted)')
          : task.axisValue,
      value: task.seriesType === 'line' ? toFixed0(task.value * 100) : newMathFormat(task.value),
    };
  });
  return ChartBubble({
    data: res,
    secondTitleRight: title, // locale === LANGUAGE_CN ? '收入（美元）' : 'Revenue($)',
    chartType: 'line',
    ifNoBarImg: true,
    topChartsType: 'metrictable-steam-price',
  });
};
// 直接加%  正是正 负是负   留存左边
export const toFixed0 = (value: string | number, point = 2) => {
  let _newVal: string | number = parseFloat(value);
  if (value == '' || isNaN(_newVal)) {
    return '-';
  }
  _newVal = _newVal.toFixed(point);
  return `${_newVal}%`;
};

const byRevenueHeaderList = ['Region', 'Revenue', 'Growth'];
const byRevenueHeaderList_cn = ['区域', '收入', '增长'];
const byPlayersHeaderList = ['Region', 'Players', 'Annual Spend/Payer($)'];
const byPlayersHeaderList_cn = ['区域', '玩家', '平均付费玩家年度付费值（美元）'];
export const marketSizeTitleListSets = [
  {
    listKey: 'countrys',
    leftValueKey: 'revenue',
    rightValueKey: 'revenue_growth',
    textFomat1: (value) => {
      return mathFormat(value, false, 0, true);
    },
    textFomat2: (value) => {
      if (isNaN(Number(value))) {
        return '-';
      }
      return `${Number(value).toFixed(2)}%`;
    },
    titles: [
      {
        title: 'Star Market',
        title_cn: '明星市场',
        headerList: byRevenueHeaderList,
        headerList_cn: byRevenueHeaderList_cn,
        type: 'Revenue+ & Growth+',
        colorPositive: '#7DADFF',
        colorNegative: '#CFE4FF',
        iconTip: `Star Markets: Markets with an income greater than or equal to the median, and an annual growth rate greater than or equal to the median, are characterized as "Star Markets". `,
        iconTip_cn: ` 明星市场：收入大于等于100个国家中位数，年增长率大于等于中位数的国家为明星市场。`,
      },
      {
        title: 'Cash Cow',
        title_cn: '成熟市场',
        headerList: byRevenueHeaderList,
        headerList_cn: byRevenueHeaderList_cn,
        type: 'Revenue+ & Growth-',
        colorPositive: '#FFABAF',
        colorNegative: '#FFE6E6',
        iconTip: `Cash Cow: Markets with an income greater than or equal to the median, but an annual growth rate less than the median, are deemed "Cash Cow Markets".`,
        iconTip_cn: `成熟市场：收入大于等于中位数，年增长率小于中位数的国家为成熟市场。`,
      },
      {
        title: 'Question Mark',
        title_cn: '问号市场',
        headerList: byRevenueHeaderList,
        headerList_cn: byRevenueHeaderList_cn,
        type: 'Revenue- & Growth+',
        colorPositive: '#92DEB4',
        colorNegative: '#DEF2E4',
        iconTip: `Question Mark :Markets with an income less than the median, yet an annual growth rate greater than or equal to the median, fall under "Question Mark Markets". `,
        iconTip_cn: `问号市场：收入小于中位数，年增长率大于等于中位数的国家为问号市场。`,
      },
      {
        title: 'Dogs',
        title_cn: '瘦狗市场',
        headerList: byRevenueHeaderList,
        headerList_cn: byRevenueHeaderList_cn,
        type: 'Revenue- & Growth-',
        colorPositive: '#FFC182',
        colorNegative: '#FFECD4',
        iconTip: `Dogs: Markets with both income and annual growth rate less than the median are labelled as "Dog Markets".`,
        iconTip_cn: `瘦狗市场：收入小于中位数，年增长率小于中位数的为瘦狗市场。`,
      },
    ],
  },
  {
    listKey: 'countrys',
    leftValueKey: 'players',
    rightValueKey: 'annual_spend_per_payer',
    textFomat1: (value) => {
      return mathFormat(value, false, 0, true);
    },
    textFomat2: (value) => {
      return mathFormat(value, false, 0, true);
    },
    titles: [
      {
        title: 'Lots of Players & Lots of Payers',
        title_cn: '玩家多,付费玩家多的国家',
        headerList: byPlayersHeaderList,
        headerList_cn: byPlayersHeaderList_cn,
        type: 'Players+ & Payers+',
        colorPositive: '#7DADFF',
        colorNegative: '#CFE4FF',
      },
      {
        title: 'Lots of Players, Few payers',
        title_cn: '玩家多,付费玩家少的国家',
        headerList: byPlayersHeaderList,
        headerList_cn: byPlayersHeaderList_cn,
        type: 'Players+ & Payers-',
        colorPositive: '#FFABAF',
        colorNegative: '#FFE6E6',
      },
    ],
  },
];
